import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

const LogoutCallback = (message) => {
    localStorage.removeItem("token");
    localStorage.removeItem("loggedInID");
    localStorage.removeItem("companyId");
    localStorage.removeItem("loggedInUsername");
    localStorage.removeItem("roleId");
    localStorage.removeItem("activeTab")

    toast.error(message, {
      position: "top-right",
      autoClose: 6000,
    });


    Navigate("/signin");
  };

export default LogoutCallback;
